import { render, staticRenderFns } from "./add-rg-user.vue?vue&type=template&id=35b31474&"
import script from "./add-rg-user.vue?vue&type=script&lang=ts&"
export * from "./add-rg-user.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports